import { CNY_MALL, cnyReferenceSuffix, useCnyPerUsd } from '../lib/cnyReference';

interface CnyReferenceProps {
  amount: string | number;
  currencyCode: string;
  mall: string | null | undefined;
}

const CnyReferenceLoaded = ({ amount, currencyCode, mall }: CnyReferenceProps) => {
  const suffix = cnyReferenceSuffix(amount, currencyCode, mall, useCnyPerUsd(true));
  return suffix ? (
    <span className="whitespace-nowrap" style={{ color: 'var(--content-muted)' }} data-testid="cny-reference">
      {suffix}
    </span>
  ) : null;
};

/**
 * QA-557 — USD 금액 바로 뒤에 붙이는 위안 참고가 " (≈¥xx.xx)". 중문몰 USD 금액일 때만 환율을 읽어 붙인다
 * (그 외에는 쿼리도 만들지 않는다). 같은 환율 쿼리를 공유하므로 목록 여러 줄에 써도 한 번만 부른다.
 */
export const CnyReference = (props: CnyReferenceProps) => {
  const target =
    props.currencyCode.toUpperCase() === 'USD' &&
    (props.mall ?? '').replace('_', '-').toLowerCase() === CNY_MALL.toLowerCase();
  return target ? <CnyReferenceLoaded {...props} /> : null;
};
